import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import frCA from './locales/fr-CA.json';
import de from './locales/de.json';
import it from './locales/it.json';
import ptBR from './locales/pt-BR.json';
import ptPT from './locales/pt-PT.json';
import pl from './locales/pl.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';
import el from './locales/el.json';
import ar from './locales/ar.json';
import tl from './locales/tl.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  'fr-CA': { translation: frCA },
  de: { translation: de },
  it: { translation: it },
  'pt-BR': { translation: ptBR },
  'pt-PT': { translation: ptPT },
  pl: { translation: pl },
  ru: { translation: ru },
  zh: { translation: zh },
  el: { translation: el },
  ar: { translation: ar },
  tl: { translation: tl },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

// -------------------------------
// TIMEOUT HELPER (IMPORTANT)
// -------------------------------
function fetchWithTimeout(url, timeout = 4000) {
  return Promise.race([
    fetch(url),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Timeout')), timeout)
    ),
  ]);
}

// -------------------------------
// MULTI API GEO DETECTION (BEST)
// -------------------------------
async function getCountryCode() {
  try {
    // 🔥 PRIMARY API (FAST)
    let res = await fetchWithTimeout('https://ipwho.is/');
    let data = await res.json();

    if (data?.success && data?.country_code) {
      return data.country_code;
    }
  } catch (e) {
  
  }

  try {
    // 🔥 FALLBACK API
    let res = await fetchWithTimeout('https://ipapi.co/json/');
    let data = await res.json();

    if (data?.country_code) {
      return data.country_code;
    }
  } catch (e) {
   
  }

  return null;
}

// -------------------------------
// COUNTRY → LANGUAGE MAP
// -------------------------------
const countryMap = {
  FR: 'fr',
  CA: 'fr-CA',
  DE: 'de',
  IT: 'it',
  ES: 'es',
  BR: 'pt-BR',
  PT: 'pt-PT',
  PL: 'pl',
  RU: 'ru',
  CN: 'zh',
  GR: 'el',
  SA: 'ar',
  PH: 'tl',
};

// -------------------------------
// FINAL LANGUAGE DETECTOR
// -------------------------------
async function detectAndSetLanguage() {
  try {
    const country = await getCountryCode();

 

    if (country && countryMap[country]) {
      await i18n.changeLanguage(countryMap[country]);

      return;
    }

    // -----------------------
    // FALLBACK 1: BROWSER
    // -----------------------
    const browserLang = navigator.language?.split('-')[0];

    if (browserLang && resources[browserLang]) {
      await i18n.changeLanguage(browserLang);
   
      return;
    }

    // -----------------------
    // FINAL FALLBACK
    // -----------------------
    await i18n.changeLanguage('en');


  } catch (err) {

    await i18n.changeLanguage('en');
  }
}

// RUN ON APP START
detectAndSetLanguage();

export default i18n;